import { render, staticRenderFns } from "./homeindex.vue?vue&type=template&id=2b69372a&"
import script from "./homeindex.vue?vue&type=script&lang=js&"
export * from "./homeindex.vue?vue&type=script&lang=js&"
import style0 from "./homeindex.vue?vue&type=style&index=0&id=2b69372a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports